import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from '../app.component';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-pending-user',
  templateUrl: './pending-user.component.html',
  styleUrls: ['./pending-user.component.css'],
})
export class PendingUserComponent implements OnInit {
  isConfirmed: boolean = false;
  email: string;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private appComponent: AppComponent
  ) {}

  ngOnInit() {
    this.appComponent.setTitle('Verify Email');

    this.email = localStorage.getItem('pendingEmail')
  }
}
